/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseGlobalConfigFragment, GlobalConfigFragment, FullGlobalConfigFragment} from '@amblique/contentful/app/contentful/fragments/global-config';

/**
 * Get a single GlobalConfig by ID (base - scalars only)
 */
export const getBaseGlobalConfigById = gql`
  ${BaseGlobalConfigFragment}

  query GetBaseGlobalConfigById($id: String!, $locale: String!, $preview: Boolean) {
    globalConfig(id: $id, locale: $locale, preview: $preview) {
      ...BaseGlobalConfigFragment
    }
  }
`;

/**
 * Get a single GlobalConfig by ID (standard - 1 level deep)
 */
export const getGlobalConfigById = gql`
  ${GlobalConfigFragment}

  query GetGlobalConfigById($id: String!, $locale: String!, $preview: Boolean) {
    globalConfig(id: $id, locale: $locale, preview: $preview) {
      ...GlobalConfigFragment
    }
  }
`;

/**
 * Get a single GlobalConfig by ID (full - 2 levels deep)
 */
export const getFullGlobalConfigById = gql`
  ${FullGlobalConfigFragment}

  query GetFullGlobalConfigById($id: String!, $locale: String!, $preview: Boolean) {
    globalConfig(id: $id, locale: $locale, preview: $preview) {
      ...FullGlobalConfigFragment
    }
  }
`;

/**
 * Get all GlobalConfig entries with pagination (base - scalars only)
 */
export const getBaseGlobalConfigs = gql`
  ${BaseGlobalConfigFragment}

  query GetBaseGlobalConfigs(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [GlobalConfigOrder]
    $where: GlobalConfigFilter
    $preview: Boolean
  ) {
    globalConfigCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseGlobalConfigFragment
      }
    }
  }
`;

/**
 * Get all GlobalConfig entries with pagination (standard - 1 level deep)
 */
export const getGlobalConfigs = gql`
  ${GlobalConfigFragment}

  query GetGlobalConfigs(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [GlobalConfigOrder]
    $where: GlobalConfigFilter
    $preview: Boolean
  ) {
    globalConfigCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...GlobalConfigFragment
      }
    }
  }
`;

/**
 * Get all GlobalConfig entries with pagination (full - 2 levels deep)
 */
export const getFullGlobalConfigs = gql`
  ${FullGlobalConfigFragment}

  query GetFullGlobalConfigs(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [GlobalConfigOrder]
    $where: GlobalConfigFilter
    $preview: Boolean
  ) {
    globalConfigCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullGlobalConfigFragment
      }
    }
  }
`;
